module.exports = __webpack_public_path__ + "fonts/d158f6fda21613842f06f139618c4865.txt";